import { render, staticRenderFns } from "./PosterFilterBar.vue?vue&type=template&id=6bb664f0"
import script from "./PosterFilterBar.vue?vue&type=script&lang=ts"
export * from "./PosterFilterBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports